import {useRef} from 'react'

import PropTypes from 'prop-types'

import {useMount} from '@s-ui/react-hooks'
import Layout from '@adv-mt/mt-layout-basic'

import {useLandingInstantOfferTracking} from '../../../useLandingInstantOfferTracking.js'
import CardsBenefits from './components/CardsBenefits/index.js'
import Faqs from './components/Faqs/index.js'
import HeroForm from './components/HeroForm/index.js'
import PanelLearnC2BProcess from './components/PanelLearnC2BProcess/index.js'

const LandingInstantOfferStepLanding = ({onGetVehicles, sellerVehicle}) => {
  const {pageTrackLandingStep} = useLandingInstantOfferTracking()

  useMount(() => {
    pageTrackLandingStep()
  })

  const plateFormRef = useRef(null)

  return (
    <>
      <HeroForm onGetVehicles={onGetVehicles} ref={plateFormRef} sellerVehicle={sellerVehicle} />
      <Layout.Container isFullWidth isMarginless>
        <CardsBenefits />
      </Layout.Container>
      <PanelLearnC2BProcess plateFormRef={plateFormRef} />
      <Layout.Container isFullWidth isMarginless>
        <Faqs />
      </Layout.Container>
    </>
  )
}

LandingInstantOfferStepLanding.displayName = 'LandingInstantOfferStepLanding'

LandingInstantOfferStepLanding.propTypes = {
  onGetVehicles: PropTypes.func.isRequired,
  sellerVehicle: PropTypes.shape({km: PropTypes.string.isRequired, plate: PropTypes.string.isRequired}).isRequired
}

export default LandingInstantOfferStepLanding
